
export interface IInvoice {
  id: string;
  amount: number;
  projectId?: string;
  projectName?: string;
  campaignId?: string;
  campaignName?: string;
  sentDate?: Date;
  // to remove
  dealName: string;
  dealType: string;
  dealHubspotId: string;
  companyId: string;
  invoiceStatus?: string;
  invoiceNotes?: string;
  createdAt: Date;
  updatedAt?: Date;
  closeDate?: Date;
  // end to remove
  // use for Features.PlgExternal3
  number: string;
  pdfUrl: string;
  products: string;
  dueDate?: Date;
  status: string;
  // end of use for Features.PlgExternal3
}

export const INVOICE_NUMBER = 'invoiceNumber';

export const isInvoice = (obj: unknown): obj is IInvoice => {
  return typeof obj === 'object' &&
    obj !== null &&
    'number' in obj &&
    typeof obj.number === 'string' &&
    'pdfUrl' in obj &&
    typeof obj.pdfUrl === 'string' &&
    'products' in obj &&
    typeof obj.products === 'string' &&
    'amount' in obj &&
    typeof obj.amount === 'number';
};
